import React from 'react'

export default function StringToHtml(props) {

 const parser = new DOMParser();
const doc = parser.parseFromString(props.stringValue, 'text/html');
const elements = [];

const parseNode = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    const children = Array.from(node.childNodes).map(parseNode);
    const props = {
     key: node.nodeName + (Math.random()* 100 )
    };

    for (const attr of node.attributes) {
      props[attr.name] = attr.value;
    }

    return React.createElement(node.tagName.toLowerCase(), props, children);
  }
};

Array.from(doc.body.childNodes).forEach((node) => {
  elements.push(parseNode(node));
});
  return (
    <div>{elements.map(ele => ele)}</div>
  )
}
